export default "__VITE_ASSET__BN0g_VP$__"